import {Form} from '../../../stores/Form';

export const reorganizeRecordsAfterDelete = (currentForm: Form) => {
    if (currentForm.records.length < 2) {
        currentForm.insertEmptyRecord(currentForm.records.length);
    }
    const currentColumnIndex = currentForm.currentColumn.index || 0;
    currentForm.tableAPI.focusCell(currentColumnIndex, Math.max(currentForm.currentRow - 1, 0));
};
